import { CloseButton, Dialog, Portal, Text } from "@chakra-ui/react";
import { ReactNode } from "react";

export const CustomDialog = ({
  header,
  children,
  footer,
  trigger,
  size,
  onClose,
}: {
  header: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
  trigger?: ReactNode;
  size?: "sm" | "md" | "lg" | "xl" | "xs" | "cover" | "full";
  onClose?: () => void;
}) => {
  return (
    <Dialog.Root
      open
      onOpenChange={({ open }) => {
        if (!open) {
          onClose?.();
        }
      }}
      placement="center"
      size={size}
      scrollBehavior={"inside"}
    >
      {trigger ? <Dialog.Trigger asChild>{trigger}</Dialog.Trigger> : null}
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content onClick={(e) => e.stopPropagation()}>
            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
            <Dialog.Header>
              <Text fontWeight={"semibold"} fontSize={"lg"}>
                {header}
              </Text>
            </Dialog.Header>
            <Dialog.Body>{children}</Dialog.Body>
            {footer ? <Dialog.Footer>{footer}</Dialog.Footer> : null}
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};
